import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const ACCENT = '#2B7FFF';

const sections = [
  { title: '1. Information We Collect', body: 'We collect information you provide when signing up, booking appointments, or using our platform. This includes your name, phone number, email address, and appointment details.' },
  { title: '2. How We Use Your Information', body: 'We use your information to provide booking services, send appointment reminders via SMS and email, communicate platform updates, and improve our services.' },
  { title: '3. SMS Communications', body: 'By providing your phone number, you consent to receive SMS messages from Mane including appointment confirmations, reminders, and platform updates. Reply STOP to unsubscribe at any time. Message and data rates may apply.' },
  { title: '4. Data Sharing', body: 'We do not sell your personal information. We may share data with service providers (Stripe for payments, Twilio for SMS) as necessary to operate the platform.' },
  { title: '5. Data Security', body: 'We use industry-standard encryption and security practices to protect your data. All payment information is processed securely through Stripe.' },
  { title: '6. Your Rights', body: 'You may request access to, correction of, or deletion of your personal data by contacting us at christiangflairbiz@gmail.com.' },
  { title: '7. Contact', body: 'Christian G Flair LLC · Royal Palm Beach, FL · christiangflairbiz@gmail.com · (561) 888-5567' },
];

export default function Privacy() {
  return (
    <div style={{ background: 'transparent', color: '#fff', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
      <Helmet>
        <title>Privacy Policy — Mane</title>
        <meta name="description" content="Mane privacy policy. How we collect, use, and protect your data." />
      </Helmet>
      <div style={{ maxWidth: '760px', margin: '0 auto', padding: '64px 24px 80px' }}>

        {/* Header */}
        <div style={{ marginBottom: '48px', paddingBottom: '32px', borderBottom: '1px solid #1a1a1a' }}>
          <div style={{ color: ACCENT, fontSize: '11px', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', marginBottom: '16px' }}>
            MANE
          </div>
          <h1 style={{ fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 900, letterSpacing: '-0.02em', marginBottom: '8px' }}>
            Privacy Policy
          </h1>
          <p style={{ color: '#7A8499', fontSize: '13px' }}>Last updated: March 26, 2026</p>
        </div>

        {/* Sections */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
          {sections.map((s, i) => (
            <div key={i} style={{ paddingBottom: '32px', borderBottom: '1px solid #141414' }}>
              <h2 style={{ color: '#fff', fontSize: '15px', fontWeight: 700, marginBottom: '10px', letterSpacing: '0.01em' }}>{s.title}</h2>
              <p style={{ lineHeight: 1.8, color: '#9CA3B4', fontSize: '14px' }}>{s.body}</p>
            </div>
          ))}
        </div>

        {/* Footer nav */}
        <div style={{ marginTop: '48px', display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
          <Link to="/terms" style={{ color: ACCENT, fontSize: '13px', fontWeight: 600 }}>Terms of Service →</Link>
          <Link to="/book" style={{ color: '#7A8499', fontSize: '13px' }}>Book Appointment</Link>
        </div>
      </div>
    </div>
  );
}
